import { IAppointmentResItem } from 'services/types/response';
import { AppointmentStatus } from 'Turn/services/constants';
import moment from 'utils/moment';

// Format the backend uses for `strStartTime` / `strEndTime` on getListAppointment.
const LIST_TIME_FORMAT = 'hh:mm A MM-DD-YYYY';

export type ISameDayAppointmentRow = {
  id: number;
  date: string; // MM-DD-YYYY
  timeRange: string; // 04:00 PM - 04:45 PM
  staffName: string;
  serviceNames: string;
};

/**
 * Only appointments the customer still has to be served for count as "already booked":
 * a check-in or finished visit is not a reason to warn about a new booking that day.
 */
const isPendingAppointment = (o: IAppointmentResItem) =>
  o.status === AppointmentStatus.NEW || o.status === AppointmentStatus.CONFIRMED;

export const toSameDayRows = (list: IAppointmentResItem[]): ISameDayAppointmentRow[] =>
  list
    .filter(isPendingAppointment)
    .map(o => ({ o, start: moment(o.strStartTime, LIST_TIME_FORMAT) }))
    .sort((a, b) => a.start.valueOf() - b.start.valueOf())
    .map(({ o, start }) => ({
      id: o.id,
      date: start.format('MM-DD-YYYY'),
      timeRange: `${start.format('hh:mm A')} - ${moment(o.strEndTime, LIST_TIME_FORMAT).format('hh:mm A')}`,
      staffName: o.staffName?.trim() || 'Anyone',
      serviceNames: (o.services || []).map(s => s.serviceName).filter(Boolean).join(', '),
    }));
